export default "__VITE_ASSET__DsQC3eSd__"